import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { TILE_TAG_BORDER_RADIUS } from '../HotelTile.constants';
import type { BadgesProps } from '../HotelTile.types';

export const Badges: React.FC<BadgesProps> = React.memo(({ items }) => {
  if (items.length === 0) return null;

  return (
    <Flex
      alignItems="center"
      flexWrap="wrap"
      gap={pxToRem(6)}
    >
      {items.map(item => (
        <Flex
          key={item.label}
          alignItems="center"
          justifyContent="center"
          backgroundColor="mono2"
          borderRadius={pxToRem(TILE_TAG_BORDER_RADIUS)}
          paddingX={2}
          paddingY={1}
          flexShrink={0}
        >
          <TextV2
            typographyVariant="label3"
            color="mono12"
          >
            {item.label}
          </TextV2>
        </Flex>
      ))}
    </Flex>
  );
});

Badges.displayName = 'HotelTile.Badges';
